import api from '@/lib/api'

export default {
  namespaced: true,
  state: {
    recommendedProductCategories: [],
    recommendedServiceCategories: [],
    allProductCategories:[],
    allServiceCategories:[],
    rfq: [],
    tenders:[],
    subProductCategoryMenu: { CategoryList: []},
    subServiceCategoryMenu: { CategoryList: []}
  },
  mutations: {
    setRecommendedProductCategories(state, categories) {
      state.recommendedProductCategories = categories;
    },
    setRecommendedServiceCategories(state, categories) {
      state.recommendedServiceCategories = categories;
    },
    setAllProductCategories(state, categories) {
      state.allProductCategories = categories;
    },
    setAllServiceCategories(state, categories) {
      state.allServiceCategories = categories;
    },
    setRfq(state, rfq) {
      state.rfq = rfq;
    },
    setTenders(state, tenders) {
      state.tenders = tenders;
    },
    setProductSubCategories(state, subCategoryMenu) {
      state.subProductCategoryMenu = subCategoryMenu;
    },
    setServiceSubCategories(state, subCategoryMenu) {
      state.subServiceCategoryMenu = subCategoryMenu;
    }
  },
  actions: {
    async fetchRecommendedCategories({ commit }) {
      const response = await api.getCategories()
      var productCategories = response.data.Result.filter(category => category.CategoryType == 'Product');
      var serviceCategories = response.data.Result.filter(category => category.CategoryType == 'Service');
      commit('setRecommendedProductCategories', productCategories)
      commit('setRecommendedServiceCategories', serviceCategories)

      setTimeout(function () {
          var evt = new CustomEvent('owl-initialize', {  });
          window.dispatchEvent(evt);
        }, 50)

    },
    async fetchAllCategories({ commit }) {
      const response = await api.getAllCategories()
      var productCategories = response.data.Result.filter(category => category.TypeName == 'Product');
      commit('setAllProductCategories', productCategories)

      var serviceCategories = response.data.Result.filter(category => category.TypeName == 'Service');
      commit('setAllServiceCategories', serviceCategories)
    },
    async fetchRfqTenderList( {commit}) {
      const response = await api.getRfqTenderList()

      commit('setRfq', response.data.RfqResult)
      commit('setTenders', response.data.TenderResult)
    },
    async fetchProductSubCategories({ commit }, { categoryId }) {
      const response = await api.getProductSubCategories(categoryId)
      commit('setProductSubCategories', response.data)
    },
    async fetchServiceSubCategories({ commit }, { categoryId }) {
      const response = await api.getServiceSubCategories(categoryId)
      commit('setServiceSubCategories', response.data)
    }
  }
}
